import { render, staticRenderFns } from "./FlyingButton.vue?vue&type=template&id=0f2d9435&scoped=true&"
import script from "./FlyingButton.vue?vue&type=script&lang=js&"
export * from "./FlyingButton.vue?vue&type=script&lang=js&"
import style0 from "./FlyingButton.vue?vue&type=style&index=0&id=0f2d9435&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2d9435",
  null
  
)

export default component.exports